export const jsonStringToObject = ({ value }: { value: unknown }) => {
	if (typeof value === 'string') {
		return JSON.parse(value);
	}

	return value;
}
